export default __webpack_public_path__ + "static/medgas_manifold_w.b1609e986b63abf34e217e8ba999cb8d.svg";